<template>
  <div class="searcher">

    <div class="input-wrapper">
      <input v-if="!itemSelect" v-model="searchText" placeholder="Поиск">

      <div v-if="searchText" class="items-list" >
        <div v-for="item in filteredItems" :key="item.id" @click="selectItem(item)">

          <div class="item hover liner" v-if="model === 'drivers'">
            {{ item.first_name }} - {{ item.phone }}
          </div>

          <div class="item hover" v-if="model === 'managers'">
          {{ item.name }} - {{ item.phone }}
          </div>

          <div class="item hover" v-if="model === 'cars' || model === 'trailers'">
          {{ item.number }}
          </div>

          <div class="item hover" v-if="model === 'companies'">
            {{ shortNameCompany(item.name) }}
          </div>
        </div>
      </div>

      <div v-if="itemSelect" class="data-block">

        <div class="data-label" v-if="model === 'drivers'">
          <p>ID: <span>{{ itemSelect.id }} </span></p>
          <p>Имя: <span>{{ itemSelect.first_name }} </span></p>
          <p>Телефон: <span>{{ itemSelect.phone }} </span></p>
        </div>

        <div class="data-label" v-if="model === 'managers'">
          <p>ID: <span>{{ itemSelect.id }} </span></p>
          <p>Имя: <span>{{ itemSelect.name }}</span></p>
          <p>Телефон: <span>{{ itemSelect.phone }}</span></p>
        </div>

        <div class="data-label" v-if="model === 'cars' || model === 'trailers'">
          <p>ID: <span>{{ itemSelect.id }} </span></p>
          <p>Номер: <span>{{ itemSelect.number }} </span></p>
        </div>

        <div class="data-label" v-if="model === 'companies'">
          <p>ID: <span>{{ itemSelect.id }} </span></p>
          <p>Название: <span>{{ shortNameCompany(itemSelect.name) }}</span></p>
          <p>ИНН: <span>{{ itemSelect.inn }}</span></p>
        </div>
               
      </div>
      <button
      v-if="itemSelect"
      class="select-button bg-denied" 
      @click="resetItem">Отменить
      </button>

    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import ApiConnector from '@/backend/apiModels/userApi'


export default {
  name: 'wizard-search',
  props:['model','itemSelect'],
  setup(props,{emit}) {
    const store = useStore();
    const api = new ApiConnector()
    const {response,request} = api.getItems('/wizard-search',{model:props.model})
    
    const searchText = ref('');
    const items = ref([])

    const shortNameCompany = name =>{
      var substr = 'Индивидуальный предприниматель'
      if(name.includes(substr)){
        return name.replace('Индивидуальный предприниматель', 'ИП')
      }else{
        return name
      }

    }

    const getItems = async ()=>{
      await request()
      items.value = response.value
    }

    if (!items[0]) getItems()
    
    const filteredItems = computed(() => {
      return items.value.filter((item) => {
        const lowerSearchText = searchText.value.toLowerCase();
        const searchNumber = searchText.value.replace(/\D/g, '').slice(-10);

        return searchFields.value.some(field => {
          if (field === 'phone' && searchNumber.length > 0) {
            // Убираем все символы, кроме цифр, и берем последние 10 цифр
            const phone = lowerSearchText.replace(/\D/g, '').slice(-10);
            return item[field].includes(phone);
          } else {
            return item[field].toLowerCase().includes(lowerSearchText);
          }
        });
      });
    });

    const searchFields = computed(() => {
      if (props.model === 'drivers') {
        return ['first_name', 'phone'];
      } else if (props.model === 'companies') {
        return ['name', 'inn'];
      } else if (props.model === 'managers') {
        return ['name', 'phone'];
      } else if (props.model === 'cars' || props.model === 'trailers') {
        return ['number'];
      } 
    });

    const selectItem = item =>{
      searchText.value = ''
      emit('update:itemSelect',item)
    }

    const resetItem = ()=>{
      emit('update:itemSelect',null)
    }

    const createItem = ()=>{
      searchText.value = ''
      emit('createItem',true)
    }

    return {
      resetItem,
      shortNameCompany,
      searchText,
      filteredItems,
      selectItem,
      createItem,
    };
  },
};
</script>


<style scoped>


.input-wrapper input {
  width: 300px;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 6px;
  font-size: 12px;
}

.items-list{
  overflow-y: auto;
/*  max-width: 250px;*/
  max-height: 200px;
  margin-top: 2px;
  border: 1px solid #ccc;
  border-radius: 3px;
  text-align: left;
}

.item{
  padding: 3px;
  border-bottom: 1px solid #ccc;
}

.hover:hover{
  cursor: pointer;
  background-color: rgba(204, 204, 204, 0.3);
}

.select-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}

/* Стили для кнопки "Выбрать" при наведении */
.select-button:hover {
  background-color: #0056b3;
}

.data-block {
  max-width: 250px;
  height: 100px;
  margin-top: 2px;
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 10px;
}

.data-item {
  margin-bottom: 5px;
}

.data-label p{
  font-weight: bold;
  margin-right: 5px;
}

.data-label span{
  font-weight: normal;
  margin-right: 5px;
}

</style>
